import React, { useEffect, useRef, useState } from 'react';
import './About.css';
import GONZALO from './images/GONZALO.jpeg';
import PABLOF from './images/PABLOF.jpg';
import FERNANDO from './images/FERNANDO.jpg';
import PABLO from './images/PABLO.jpg';
import JAVIER from './images/JAVIER.jpg';
import JLCASAL from './images/JLCASAL.png';
import ARTURO from './images/ARTURON.png';

const About = () => {
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const titleRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === titleRef.current) {
            setIsTitleVisible(entry.isIntersecting);
          }
        });
      },
      { threshold: 0.5 }
    );

    const currentRef = titleRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section id="about" className="about-section">
      <h1
        ref={titleRef}
        className={`about-title ${isTitleVisible ? 'slide-in' : ''}`}
      >
        CONOCE AL EQUIPO
      </h1>

      <div className="about-grid">
        {/* Gonzalo */}
        <div className="about-widget">
          <div className="widget-content">
            <div className="widget-img">
              <img src={GONZALO} alt="GonzaloRuiz" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">Gonzalo Ruiz Julián</h2>
              <h3 className="team-member-position">Director General</h3>
              <p className="team-member-description">
                Director y emprendedor movido por la excelencia, con una visión estratégica amplia,
                capacidad de innovación y enfoque estructurado en desarrollo corporativo.
              </p>
              <p className="team-member-description">
                Experto en gestión, desarrollo empresarial e inversiones, consolidando alianzas estratégicas.
              </p>
            </div>
          </div>
        </div>

        {/* Fernando */}
        <div className="about-widget">
          <div className="widget-content">
            <div className="widget-img">
              <img src={FERNANDO} alt="FernandoCuesta" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">Fernando Cuesta</h2>
              <h3 className="team-member-position">Senior Partner BMS</h3>
              <p className="team-member-description">
                Con más de 40 años en el sector BMS, experto en democratizar sistemas para hacerlos más eficientes y accesibles.
              </p>
              <p className="team-member-description">
                Ha liderado proyectos de automatización de edificios en grandes corporaciones impulsando la eficiencia energética.
              </p>
            </div>
          </div>
        </div>

        {/* Javier */}
        <div className="about-widget">
          <div className="widget-content">
            <div className="widget-img">
              <img src={JAVIER} alt="JavierSolueta" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">Javier Solueta</h2>
              <h3 className="team-member-position">CTO</h3>
              <p className="team-member-description">
                Especialista en aplicar tecnología a negocios, identificando oportunidades e implementando soluciones con baja fricción tecnológica.
              </p>
              <p className="team-member-description">
                Más de 25 años de experiencia en innovación en múltiples sectores.
              </p>
            </div>
          </div>
        </div>

        {/* Pablo Latasa */}
        <div className="about-widget">
          <div className="widget-content">
            <div className="widget-img">
              <img src={PABLO} alt="PabloLatasa" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">Pablo Latasa</h2>
              <h3 className="team-member-position">Senior Partner</h3>
              <p className="team-member-description">
                Más de 35 años impulsando proveedores de software en Europa, América y Oriente Medio.
              </p>
              <p className="team-member-description">
                Experto en interacción, organización y pasión por el trabajo bien hecho.
              </p>
            </div>
          </div>
        </div>

        {/* Pablo Fernández */}
        <div className="about-widget">
          <div className="widget-content">
            <div className="widget-img">
              <img src={PABLOF} alt="PabloFernández" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">Pablo Fernández de la Torre</h2>
              <h3 className="team-member-position">Senior Partner</h3>
              <p className="team-member-description">
                Experto en gestión energética y control de instalaciones. Cofundador de startups en Energías Limpias como Grupo Alium y N2ESE.
              </p>
              <p className="team-member-description">
                Fue CEO de N2S y consultor en McKinsey & Company.
              </p>
            </div>
          </div>
        </div>

        {/* José Luis Casal */}
        <div className="about-widget">
          <div className="widget-content">
            <div className="widget-img">
              <img src={JLCASAL} alt="JoseLuisCasal" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">José Luis Casal Castro</h2>
              <h3 className="team-member-position">Senior Partner</h3>
              <p className="team-member-description">
                Socio fundador de varios proyectos tecnológicos y miembro de consejos de empresas y gestoras de capital riesgo.
              </p>
              <p className="team-member-description">
                TOP Voice en LinkedIn y miembro del consejo de Harvard Business Review, con más de 50.000 suscriptores en su newsletter.
              </p>
            </div>
          </div>
        </div>

        {/* Arturo */}
        <div className="about-widget arturo">
          <div className="widget-content">
            <div className="widget-img">
              <img src={ARTURO} alt="Arturo" />
            </div>
            <div className="widget-info">
              <h2 className="team-member-name">Arturo Nevado</h2>
              <h3 className="team-member-position">Senior Partner Marketing & Innovación</h3>
              <p className="team-member-description">
                Más de 24 años de experiencia en marketing, desarrollo de negocio e innovación en multinacionales y proyectos propios. Cofundador de la influencer Mimodemami con más de 800.000 seguidores.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default About;